import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';

class ContainerService {
    static configContainer = () => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        if (platformId && token) {
            return fetchAPI({
                token,
                url: `${config.FileDelivery}config-container/${platformId}/${token}`,
                method: 'GET',
                parseJSON: false,
            });
        } else {
            return Promise.resolve();
        }
    }

    static getOnlineStatus = () => {
        let appContext = new AppContext();
        let config = appContext.getConfig();

        return fetchAPI({
            token: '',
            url: `${config.FileDelivery}online-status`,
            method: 'GET'
        });
    }

    static containerIsCapable = (fileId) => {
        let appContext = new AppContext();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: '',
            url: `${config.FileDelivery}is-capable/${platformId}/${fileId}`,
            method: 'GET'
        });
    }

    static openFileInContainer = (fileId) => {
        let appContext = new AppContext();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: '',
            url: `${config.FileDelivery}open-file/${platformId}/${fileId}`,
            method: 'GET',
            parseJSON: false,
        });
    }

    static openLinkInContainer = (body) => {
        let appContext = new AppContext();
        let config = appContext.getConfig();

        return fetchAPI({
            token: '',
            url: `${config.FileDelivery}open-link/`,
            method: 'POST',
            body,
            parseJSON: false,
        });
    }

    static shareExternal = (reference, attachments, onlyLinks, emailDone) => {
        let appContext = new AppContext();
        let config = appContext.getConfig();

        return fetchAPI({
            token: '',
            url: `${config.FileDelivery}share-external/`,
            method: 'POST',
            body: {
                reference,
                // body,
                attachments,
                onlyLinks,
                emailDone
            },
            parseJSON: false,
        });
    }
}

export default ContainerService;